module.exports = __webpack_public_path__ + "img/current-ranking.91586cf8.png";